module.exports = __webpack_public_path__ + "img/LIE.9923eae3.svg";